import {
	Component, OnInit, Output, VERSION, ViewChild,
	Input,
	EventEmitter
} from '@angular/core'
import { AWSService } from '../../../services/aws.service'
import { SchedulingService } from 'src/app/services/scheduling.service'
import { environment } from 'src/environments/environment'
import { Problems } from 'src/app/models/Problems'
import { CompanyService } from 'src/app/services/company.service'
import { ViewValidation } from 'src/app/_helpers/ViewValidation'
import { DemandService } from 'src/app/services/demand.service'
import { NgForm } from '@angular/forms'
import { SchedulerComponent } from '../scheduler/scheduler.component'
import { Company, DataCsv, objectWithPositionFieldReport } from 'src/app/models/DataCsv'
import { getUniqueId } from 'src/app/_helpers/Utils'

@Component({
	selector: 'app-data-csv',
	templateUrl: './data-csv.component.html'
})

export class DataCsvComponent implements OnInit {

	public problems: Array<Problems>
	public records: any = []
	public imagesWantDownload = []
	public company: Company

	@Output() public getDemands: any = new EventEmitter()
	@Output() public clearImage: any = new EventEmitter()


	constructor(
		private awsService: AWSService,
		private demandService: DemandService,
		private companyService: CompanyService,
		private schedulingService: SchedulingService

	) { }
	public ViewValidation: ViewValidation = new ViewValidation()

	public schedulerComponent: SchedulerComponent

	@ViewChild('form') public form: NgForm
	public openModalListImages: boolean = false
	public openFeedbackImages: boolean = false
	public nameFilesImage: any = []
	public titulo: string
	public isLoading: any
	public openFeedbackCvs: boolean = false
	public disabledButtonCancelCvs: boolean = true

	public disabledButtonSubmitImage = false


	public async ngOnInit(): Promise<void> {
		this.isLoading = 'Sim'
		this.disabledButtonSubmitImage = false

		await this.getProblems()
	}

	public async getProblems(): Promise<void> {
		try {
			this.problems = await this.schedulingService
				.getProblems()
				.toPromise()

		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}
	}

	public findProblem(nameProblem: any) {
		if (nameProblem !== undefined) {
			const existsThisProblem = this.problems.find(item => item.name.toLowerCase() === nameProblem.toLowerCase())
			return existsThisProblem
		}

		return ''
	}

	public async findDetailsCompany(nameCompany) {
		try {
			const response: any = await this.companyService
				.getCompanyByName(nameCompany)
				.toPromise()

			return response

		} catch (err) {
			throw new Error('[ERROR] Cliente não existe ou foi removido do sistema')
		}
	}


	public listImagesForUser($event: any): void {
		this.isLoading = 'Sim'
		this.disabledButtonSubmitImage = false
		this.nameFilesImage = []


		document.querySelector('main').className = 'modal-active'
		this.openModalListImages = true

		const files = $event.srcElement.files
		this.imagesWantDownload = files

		for (let i = 0; i < files.length; i++) {
			this.nameFilesImage.push(files[i].name)
		}

		this.openModalListImages = true
	}

	public async uploadImages(): Promise<any> {
		this.disabledButtonSubmitImage = true
		const imagesUploaded = []

		for (let i = 0; i < this.imagesWantDownload.length; i++) {
			const fileWithNewName =  new File([this.imagesWantDownload[i]], getUniqueId() + '-' + this.imagesWantDownload[i].name, {
				type: this.imagesWantDownload[i].type,
				lastModified: this.imagesWantDownload[i].lastModified
		})
			const data = await this.awsService.uploadToS3(fileWithNewName)
			imagesUploaded.push(data.Location)

			this.isLoading = `Carregando... ${i}/${this.imagesWantDownload.length}`
		}

		this.openModalListImages = false
		this.openFeedbackImages = true

		localStorage.setItem('imagesUploaded', JSON.stringify(imagesUploaded))
	}


	public uploadCvs($event: any) {

		const files = $event.srcElement.files

		if (this.isValidCSVFile(files[0])) {
			const input = $event.target
			const reader = new FileReader()
			reader.readAsText(input.files[0])

			reader.onload = async () => {
				const csvData = reader.result
				const csvRecordsArray = (csvData).split(/\r\n|\n/)

				const headersRow = this.getHeaderArray(csvRecordsArray)

				this.records = await this.readDataCvs(csvRecordsArray, headersRow.length)

			}

			reader.onerror = function() {
				console.log('Error enquanto estava processando o arquivo!')
			}

		} else {
			alert('Por favor, importe um arquivo .csv')
		}
	}


	public async readDataCvs(csvRecordsArray: any, headerLength: any): Promise<void> {
		try {
			const csvArr = []
			let objWithPositionFieldReport: objectWithPositionFieldReport

			for (let i = 0; i < csvRecordsArray.length ; i++) {

				let currentData
				if (csvRecordsArray[i].includes(',')) {
					currentData = (csvRecordsArray[i]).split(',')
				}
				if (csvRecordsArray[i].includes(';')) {
					currentData = (csvRecordsArray[i]).split(';')
				}

				const csvRecord: DataCsv = new DataCsv()

				if (i === 0) {
					objWithPositionFieldReport = this.getPositionFieldOfReport(currentData)
				} else {
					csvRecord.requester = currentData[objWithPositionFieldReport.nome]
					csvRecord.email_requester = currentData[objWithPositionFieldReport.email]
					csvRecord.tel_requester = currentData[objWithPositionFieldReport.fone]
					csvRecord.cpf_requester = currentData[objWithPositionFieldReport.cpf]
					csvRecord.address = {
						lat: currentData[objWithPositionFieldReport.latitude],
						lng: currentData[objWithPositionFieldReport.longitude],
						street: currentData[objWithPositionFieldReport.endereço]

					}
					csvRecord.process = currentData[objWithPositionFieldReport.processo]
					csvRecord.mediaUrl.push(currentData[objWithPositionFieldReport.foto1])
					csvRecord.mediaUrl.push(currentData[objWithPositionFieldReport.foto2])

					csvRecord.company_id = currentData[objWithPositionFieldReport.companhia]
					csvRecord.reference = currentData[objWithPositionFieldReport.referencia]
					csvRecord.problems = currentData[objWithPositionFieldReport.problema]


					this.openFeedbackCvs = true

					const isValidData = await this.validation(csvRecord, i)

					if (isValidData) {
						this.isLoading = 'Validando dados do csv...'
						csvArr.push(csvRecord)
					}

					if (i == csvRecordsArray.length - 1) {
						this.isLoading = 'Validação concluida com sucesso!'
						this.isLoading = 'AGUARDE! Estamos inserindo os dados neste momento'

						this.openFeedbackCvs = true
						this.isLoading = 'Carregando...'
						const insertManySolicitations = await this.demandService.sendManySolicitation(csvArr).toPromise()
						this.isLoading = 'Solicitações geradas com sucesso!'
						this.disabledButtonCancelCvs = false
						this.getDemands.emit()

					}
				}

			}
		} catch (err) {
			this.isLoading = err
			this.disabledButtonCancelCvs = false
			this.openFeedbackCvs = true
		}
	}

	public getPositionFieldOfReport = arrayWithNamesFieldReport => {
		const formatNamesFieldsOfReport = [
			'nome',
			'cpf',
			'latitude',
			'longitude',
			'e-mail',
			'fone',
			'foto 1',
			'foto 2',
			'companhia',
			'problema',
			'endereço',
			'referencia',
			'processo'
		]

		const objectWithPositionFieldReport = formatNamesFieldsOfReport.reduce((acc, current) => {
			const data = arrayWithNamesFieldReport.findIndex(nameFieldReport => {
				return nameFieldReport.toLowerCase() === current.toLowerCase()
			})

			if (current === 'e-mail') { current = 'email' }
			if (current === 'foto 1') { current = 'foto1' }
			if (current === 'foto 2') { current = 'foto2' }

			return {
				...acc,
				[current]: data
			}
		}, {})

		return objectWithPositionFieldReport
	}

	// Validações

	public async validation(obj: DataCsv, index) {
		const imagesStoraged = JSON.parse(localStorage.getItem('imagesUploaded'))
		const idImages = obj.mediaUrl

		if (!imagesStoraged) {
			throw new Error('É necessário fazer as importações das imagens das solicitações.')
		} else {
			const imageOfRequester = idImages.map(idImage => imagesStoraged.find(imageStoraged => {
				const part = imageStoraged.split(/[\/.|-]+/)
				return (part[part.length - 2]) == idImage
			}))

			const haveTwoImagesInRequester = imageOfRequester.every(image => image)
			if (!haveTwoImagesInRequester) {
				throw new Error('É necessário ter 2 fotos para cada solicitação.')
			}

			obj.mediaUrl = imageOfRequester
		}

		if (index === 1) {
			const company: any = await this.findDetailsCompany(obj.company_id)
			this.company = company
		}

		if (obj.company_id === this.company.social_name) {
			obj.company_id = this.company._id
		}

		const problem: any = this.findProblem(obj.problems)
		const isValidData: boolean = this.ViewValidation.isValidDataCvs(
			obj.requester,
			obj.email_requester,
			obj.cpf_requester,
			obj.tel_requester,
			obj.address.lat,
			obj.address.lng,
			obj.address.street,
			obj.company_id,
			obj.reference,
			problem
		)
		if (!isValidData) {
			if (!this.company._id) {
				throw new Error('Cliente não existe ou se encontra removido do sistema.')
			}
			throw new Error('Preencha seus dados corretamente')
		} else {
			obj.problems = [problem]
			return true
		}
	}


	public isValidCSVFile(file: any) {
		return file.name.endsWith('.csv')
	}

	public getHeaderArray(csvRecordsArr: any) {
		const headers = (csvRecordsArr[0]).split(',')
		const headerArray = []
		for (let j = 0; j < headers.length; j++) {
			headerArray.push(headers[j])
		}
		return headerArray
	}

	public closeModalListImages(): void {
		this.openModalListImages = false
		document.querySelector('main').className = ''
	}

	public closeFeedbackImages(): void {
		document.querySelector('main').className = ''
		this.openFeedbackImages = false
		this.clearImage.emit()

	}

	public cancelCsv(): void {
		this.openFeedbackCvs = false
	}

	public closeFeedbackCvs(): void {
		document.querySelector('main').className = ''
		this.openFeedbackCvs = false
	}
}

